import React from 'react';
import HeadersNonAuth from '../../components/base/HeadersNonAuth';

const SolutionsPage = () => {
  return (
    <div className="bg-[#0b0d2a] text-white font-sans min-h-screen mt-10">
      <HeadersNonAuth />
      <br />
      <br />
      <section id="solutions" className="bg-[#0b0d2a] text-white px-6 lg:px-24 py-16 font-sans">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold mb-8">Solutions Designed for Every Trader</h2>

          <p className="text-xl font-semibold text-cyan-300 mb-4">
            Built for Today. Designed to Scale for Tomorrow.
          </p>

          <p className="mb-4">
            The Quantum Flo Auto Algo was engineered to adapt not only to market conditions, but to the needs of our diverse trader base. Whether you're trading with a smaller account or managing a larger portfolio, our algorithm flexes to fit your strategy and capital constraints.
          </p>

          <h3 className="text-2xl font-semibold text-white mt-8 mb-4">Account Size? We've Got You Covered.</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <strong>Under $25K?</strong><br />
              We execute <strong>single-leg options trades</strong> to help you stay compliant with pattern day trading (PDT) rules. No complex spreads. Just clean, directional setups using Calls and Puts.
            </li>
            <li>
              <strong>Over $25K?</strong><br />
              You'll have access to our <strong>spread-based strategies</strong>, which take advantage of volatility and price structure while maintaining defined risk.
            </li>
          </ul>

          <h3 className="text-2xl font-semibold text-white mt-8 mb-4">Focused on Liquidity and Precision</h3>
          <p className="mb-4">
            At launch, Quantum Flo Auto Algo will trade only the most liquid options markets: <strong>SPY, SPX, and QQQ</strong>.<br />
            Why? Liquidity, tight spreads, and institutional-grade efficiency. Our first priority is execution quality, especially as our user base grows.
          </p>

          <p className="mb-4">But we're not stopping there.</p>

          <h3 className="text-2xl font-semibold text-white mt-8 mb-4">Preparing for Scaled Growth</h3>
          <ol className="list-decimal pl-6 space-y-2">
            <li>
              <strong>Intelligent Scaling Algorithms</strong><br />
              Leveraging five proprietary execution models from our prime broker, the algo will <strong>scale in and out of trades</strong> across multiple strikes and timeframes avoiding size distortion or slippage.
            </li>
            <li>
              <strong>Basket Expansion</strong><br />
              We'll introduce a curated basket of <strong>highly liquid, option-rich stocks</strong> (think: AAPL, MSFT, NVDA, etc.) to diversify signal output and accommodate additional user flow.
            </li>
            <li>
              <strong>Futures Auto Algo (Coming Soon)</strong><br />
              A dedicated version of the Quantum Flo Auto Algo will trade <strong>equity index futures</strong>, offering global exposure, enhanced leverage, and additional trade windows.
            </li>
            <li>
              <strong>Crypto Market Integration</strong><br />
              For traders looking to capture volatility around the clock, we'll launch a <strong>crypto-adapted version</strong> of the strategy designed to exploit inefficiencies in digital assets.
            </li>
          </ol>

          <hr className="border-gray-700 my-10" />

          <h3 className="text-2xl font-semibold text-white mt-8 mb-4">Start Smart, Scale Fast</h3>
          <p className="mb-4">
            Quantum Flo isn't just a product, it's a platform. We're building for longevity, with adaptability at its core. Whether you're trading a $5K account or managing a portfolio 100x that size, we're creating solutions to <strong>grow with you</strong>.
          </p>

          <p className="font-semibold text-cyan-300">
            The future of trading is fluid. So is Quantum Flo.
          </p>
        </div>
      </section>
    </div>
  );
};

export default SolutionsPage;
